var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { staticClass: "dashboard", attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        { staticClass: "dashContent judgeView" },
        [
          _vm.resource
            ? _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Status", "label-cols-md": "2" } },
                    [
                      _c(
                        "b-form-select",
                        {
                          on: { change: _vm.doFilter },
                          model: {
                            value: _vm.filter.mbsdStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.filter, "mbsdStatus", $$v)
                            },
                            expression: "filter.mbsdStatus",
                          },
                        },
                        [
                          _c(
                            "b-form-select-option",
                            { attrs: { value: null, disabled: "" } },
                            [_vm._v("-- Please select an option --")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "0" } },
                            [_vm._v("Unverified")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "1" } },
                            [_vm._v("Verified")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: { label: "E-mail Address", "label-cols-md": "2" },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { placeholder: "Email address to find" },
                        on: { input: _vm.doFilter },
                        model: {
                          value: _vm.search.mbsdEmail,
                          callback: function ($$v) {
                            _vm.$set(_vm.search, "mbsdEmail", $$v)
                          },
                          expression: "search.mbsdEmail",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    { attrs: { label: "Full Name", "label-cols-md": "2" } },
                    [
                      _c("b-form-input", {
                        attrs: { placeholder: "Full name to find" },
                        on: { input: _vm.doFilter },
                        model: {
                          value: _vm.search.mbsdFullName,
                          callback: function ($$v) {
                            _vm.$set(_vm.search, "mbsdFullName", $$v)
                          },
                          expression: "search.mbsdFullName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-pagination-nav", {
                    attrs: {
                      "number-of-pages": _vm.maxPage,
                      "base-url": "/list/",
                      "last-number": "",
                      "use-router": _vm.useRouter,
                      align: "fill",
                      limit: "10",
                      "link-gen": _vm.linkGen,
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function ($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage",
                    },
                  }),
                  _vm._v(" "),
                  _c("b-table", {
                    attrs: {
                      striped: "",
                      hover: "",
                      items: _vm.resource.data,
                      fields: _vm.fields,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "cell(mbsdFullName)",
                          fn: function (row) {
                            return [
                              _c(
                                "b-button",
                                {
                                  staticClass: "adminListName",
                                  attrs: { size: "md" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.show(row)
                                    },
                                  },
                                },
                                [
                                  _vm.members[row.item.links.mbsdZmemId]
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            row.detailsShowing ? "👁" : "👤"
                                          ) +
                                            " " +
                                            _vm._s(
                                              _vm.members[
                                                row.item.links.mbsdZmemId
                                              ].zmemFullName
                                            )
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: "row-details",
                          fn: function (row) {
                            return [
                              row.item.detail
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          row.item.mbsdStatus == 0
                                            ? _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-button",
                                                    {
                                                      staticClass: "mb-3",
                                                      attrs: {
                                                        block: "",
                                                        variant: "success",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.verifyData(
                                                            row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Approve Data")]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          row.item.mbsdStatus == 0
                                            ? _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-button",
                                                    {
                                                      staticClass: "mb-3",
                                                      attrs: {
                                                        block: "",
                                                        variant: "warning",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.updateProfile(
                                                            row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Reject Data")]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          row.item.mbsdStatus == 1
                                            ? _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-button",
                                                    {
                                                      staticClass: "mb-3",
                                                      attrs: {
                                                        block: "",
                                                        variant: "primary",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.dataCorrection(
                                                            row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Update Data")]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        row.item.detail.linked,
                                        function (l, f) {
                                          return l[0]
                                            ? _c(
                                                "b-card",
                                                { key: f, attrs: { data: l } },
                                                [
                                                  f == "mregZmemId"
                                                    ? _c("b-card-title", [
                                                        _vm._v(
                                                          "Transaction Info"
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  f == "mmedZmemId"
                                                    ? _c("b-card-title", [
                                                        _vm._v(
                                                          "Additional Info"
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  f == "mbsdZmemId"
                                                    ? _c("b-card-title", [
                                                        _vm._v("Member Info"),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  f == "mbspZmemId"
                                                    ? _c("b-card-title", [
                                                        _vm._v("Phone Info"),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    l[0],
                                                    function (value, key) {
                                                      return _c(
                                                        "b-row",
                                                        {
                                                          key: key,
                                                          staticClass: "mb-2",
                                                          attrs: {
                                                            data: value,
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "b-col",
                                                            {
                                                              staticClass:
                                                                "text-sm-right",
                                                              attrs: {
                                                                sm: "5",
                                                              },
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  _vm._s(key)
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("b-col", [
                                                            _vm._v(
                                                              _vm._s(value)
                                                            ),
                                                          ]),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  _vm._v(" "),
                                                  row.item.mbsdStatus == 1 &&
                                                  f == "mregZmemId" &&
                                                  l[0] &&
                                                  l[0].mregStatus == 0
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          staticClass: "mb-3",
                                                          attrs: {
                                                            block: "",
                                                            variant: "primary",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.approveBallot(
                                                                l[0]
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Approve Ballot"
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                2
                                              )
                                            : _vm._e()
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: "cell(mbsdFile)",
                          fn: function (data) {
                            return [
                              data.value
                                ? _c("img", {
                                    staticStyle: { "max-width": "250px" },
                                    attrs: {
                                      src:
                                        "https://repository.race.id/view/" +
                                        `${data.value}`,
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      738107938
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/views/TableView.vue